<template>
  <v-container fluid><mx-preloader :loader-status="preloader"/>
    <v-row class="mt-4">
      <v-col class="d-flex">
        <v-btn
            style="padding: 24px 0 25px 0;"
            class="mr-7"
            elevation="2"
            color="primary"
            medium
            :to="{name: 'crm.customers'}"
        >
          <v-icon size="32">mdi-chevron-left</v-icon>
        </v-btn>
        <h1> {{ $t('customer.create.title') }}</h1>
        <v-btn
            style="padding-top: 24px; padding-bottom: 24px;"
            class="ml-auto"
            elevation="2"
            color="success"
            medium
            @click="employeeCreate"
        >
          <v-icon size="28">mdi-content-save-outline</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="8" md="8">
        <v-card>
          <v-card-title>
            {{ $t('customer.titles.personal_data') }}
          </v-card-title>
          <v-card-text>
            <v-form class="pa-4">
              <v-row>
                <v-col cols="12" md="9">
                  <v-autocomplete
                      v-model="autocomplete_watcher"
                      :items="items"
                      :loading="isLoading"
                      :search-input.sync="search"

                      clearable
                      hide-details
                      hide-selected
                      itemscope
                      :item-text="search_item_text === 0 ? 'company_name' : 'last_name'"
                      item-value="id"
                      :label="$t('customer.crm.search.customer_search_label')"
                      solo
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title>
                          {{ $t('customer.crm.search.customer_search_info') }}
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <span>{{ item.first_name }} {{ item.last_name }}         </span>
                    </template>

                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title>{{ item.company_name }} / <small style="color: #b7b7b7">{{ item.first_name }} {{ item.last_name }}</small></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col class="mt-n1" cols="12" md="2">
                  <small>{{ $t('customer.crm.search.user.title') }}</small>
                  <v-btn-toggle v-model="search_item_text" mandatory>
                    <v-btn small>
                      {{ $t('customer.crm.search.user.company_name') }}
                    </v-btn>
                    <v-btn small>
                      {{ $t('customer.crm.search.user.last_name') }}
                    </v-btn>
                  </v-btn-toggle>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="form.company_name"
                                outlined
                                hide-details
                                disabled
                                :label="$t('customer.company_name')"
                                :placeholder="$t('customer.company_name')"
                                :error="errors.company_name!==undefined"
                  ></v-text-field>
                </v-col>
                </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field v-model="form.uid"
                                outlined
                                hide-details
                                disabled
                                required
                                :label="$t('customer.uid') + ' *'"
                                :placeholder="$t('customer.uid')"
                                :error="errors.birthday!==undefined"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select v-model="form.gender"
                            :label="$t('customer.gender.title') + ' *'"
                            :items="gender_select"
                            outlined
                            disabled
                            hide-details
                            :append-icon="'mdi-chevron-down'"
                            :menu-props="{ bottom: true, offsetY: true }"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field v-model="form.first_name"
                                outlined
                                hide-details
                                disabled
                                :label="$t('customer.first_name') + ' *'"
                                :placeholder="$t('customer.first_name')"
                                required
                                :error="errors.first_name!==undefined"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="form.last_name"
                                outlined
                                hide-details
                                disabled
                                :label="$t('customer.last_name') + ' *'"
                                :placeholder="$t('customer.last_name')"
                                required
                                :error="errors.last_name!==undefined"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field v-model="form.email"
                                outlined
                                hide-details
                                type="email"
                                :label="$t('customer.email') + ' *'"
                                :placeholder="$t('customer.email')"
                                required
                                :error="errors.email!==undefined"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="form.password"
                                outlined
                                hide-details
                                disabled
                                :label="$t('customer.password') + ' *'"
                                :placeholder="$t('customer.password')"
                                required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="4" md="4">
        <v-card class="mb-6">
          <v-card-title>{{ $t('customer.titles.settings') }}</v-card-title>
          <v-card-text>
            <div class="d-flex justify-space-between align-center px-2">
              <div style="font-size: 16px;">{{ $t('customer.email_send') }}</div>
              <v-switch
                  v-model="form.email_send"
                  color="primary"
              ></v-switch>
            </div>
            <v-divider></v-divider>

            <div class="d-flex justify-space-between align-center px-2">
              <div style="font-size: 16px;">{{ $t('customer.is_blocked') }}</div>
              <v-switch
                  v-model="form.is_blocked"
                  color="primary"
              ></v-switch>
            </div>
            <v-divider></v-divider>

            <div class="d-flex justify-space-between align-center px-2">
              <div style="font-size: 16px;">{{ $t('customer.can_faq') }}</div>
              <v-switch
                  v-model="form.can_faq"
                  color="primary"
              ></v-switch>
            </div>
            <v-divider></v-divider>

            <div class="d-flex justify-space-between align-center px-2">
              <div style="font-size: 16px;">{{ $t('customer.multi_company') }}</div>
              <v-switch
                  v-model="form.multi_company"
                  color="primary"
              ></v-switch>
            </div>
<!--            <v-switch-->
<!--                v-model="form.email_send"-->
<!--                :label="$t('customer.email_send')"-->
<!--                color="primary"-->
<!--            ></v-switch>-->
<!--            <v-switch-->
<!--                v-model="form.is_blocked"-->
<!--                :label="$t('customer.is_blocked')"-->
<!--                color="primary"-->
<!--            ></v-switch>-->

<!--            <v-switch-->
<!--                v-model="form.can_faq"-->
<!--                :label="$t('customer.can_faq')"-->
<!--                color="primary"-->
<!--            ></v-switch>-->
<!--            <v-switch-->
<!--                v-model="form.multi_company"-->
<!--                :label="$t('customer.multi_company')"-->
<!--                color="primary"-->
<!--            ></v-switch>-->
          </v-card-text>
        </v-card>
        <v-card class="mb-6" style="padding-bottom: 11px;">
          <v-card-title>{{ $t('customer.titles.password') }}</v-card-title>
          <v-card-text>
            <PasswordGenerator @getPassword="getPassword"/>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar
        v-model="snackbar_error"
        top
        right
        color="red"
    >
      <template v-if="errors.uid!==undefined">
        {{ $t('customer.create.errors.user_hast') }}
      </template>
      <template v-else>
        {{ $t('customer.create.errors.required_fields') }}
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import PasswordGenerator from "@/components/PasswordGenerator";
import moment from "moment";

export default {
  components: {PasswordGenerator},
  data() {
    return {
      search_item_text: 0,
      preloader: true,
      snackbar_error: false,
      isLoading: false,
      items: [],
      search: null,
      autocomplete_watcher: null,
      form: {
        identification: '',
        uid: '',
        company_name: '',
        first_name: '',
        last_name: '',
        email: '',
        password: null,
        gender: 'female',
        is_blocked: 0,
        email_send: 0,
        multi_company: 0,
        can_faq: 0,
      },
      gender_select: [
        {
          text: this.$t('customer.gender.female'),
          value: 'female'
        },
        {
          text: this.$t('customer.gender.male'),
          value: 'male'
        },
        {
          text: this.$t('customer.gender.divers'),
          value: 'divers'
        },
        {
          text: this.$t('customer.gender.indefinite'),
          value: 'indefinite'
        },
      ],
      errors: {},
    }
  },
  watch: {
    autocomplete_watcher (id) {
      if (id === null) {return}
      const item = this.items.find(item => item.id === id)

      this.form.uid = item.id
      this.form.identification = item.identification
      this.form.company_name = item.company_name
      this.form.first_name = item.first_name
      this.form.last_name = item.last_name
      this.form.gender = item.gender
      this.form.birthday = this.getBirthday(item.birthday)
      this.form.email = item.email
    }
  },
  created() {
    this.getItems()
    setTimeout(() => {
      this.preloader = false
    }, 300)
  },
  methods: {
    getItems() {
      this.$store.dispatch('customers').then(() => {
        this.items = this.$store.getters.customers.data
        this.isLoading = false
      })
    },
    getPassword(password) {
      this.form.password = password
    },
    employeeCreate() {
      this.$store.dispatch('customerCrmCreate', this.form).then(() => {
        this.$router.replace({
          name: 'crm.customers'
        })
      }).catch(error => {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors;
            this.snackbar_error = true
            break;
        }
      })

    },
    getBirthday(date,format='YYYY-MM-DD') {
      return moment(date, format).format('DD.MM.YYYY')
    }
  }
}
</script>
